import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Mail from "@material-ui/icons/Mail";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fetch from "../fetch/auth";
import FetchSite from "../fetch/site";
import NewSnack from "../Snackbar/newSnack";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles({
  TextFieldRtl: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(135px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(167px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right",
        width: "85px"
      }
    }
  },
  TextFieldPassRtl: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(190px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(205px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  },
  TextFieldRtlResp: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(88px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(120px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right",
        width: "85px"
      }
    }
  },
  TextFieldPassRtlResp: {
    "@global": {
      ".MuiInputLabel-outlined": {
        transform: "translate(140px, 20px) scale(1)"
      },
      ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(158px, -6px) scale(0.75)"
      },
      legend: {
        textAlign: "right"
      }
    }
  }
});
function LoginForm(props) {
  const { lang, multiLang, dir } = props;
  const size = useMediaQuery("(max-width:960px)");
  const [pass, setPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    type: "error",
    message: "sample"
  });

  const { setUser, myInvoice } = props;
  const classes = useStyles();
  async function getMyInvoice(token) {
    const data = {
      query: `
      query{
        myInvoice{
          id
          status
          invoiceProducts{
            productId{
              id
              name
            }
          }
        }
      }
    `
    };
    try {
      const response = await FetchSite({
        auth: token,
        body: JSON.stringify(data)
      });
      // console.log("myInvoice", response);
      if (response.myInvoice !== null) {
        const number = response.myInvoice.invoiceProducts.length;
        myInvoice({ number, paid: true });
      }
    } catch (err) {
      console.log("login error", err);
    }
  }
  async function handelSignin(e, place) {
    e.preventDefault();
    setLoading(true);
    const data = {
      query: `
    mutation {
        loginUser{
            user{
            name
            email
            picture
            mobile
            role
            hasPassword
            }
            token
        }
        }
    `
    };
    const basic =
      "Basic " + btoa(`${e.target.username.value}:${e.target.password.value}`);
    Fetch({
      auth: basic,
      body: JSON.stringify(data)
    })
      .then(response => {
        setSnack({
          open: true,
          type: "success",
          message: multiLang["A018"][lang]
        });
        getMyInvoice(response.loginUser.token);
        setLoading(false);
        setUser(response.loginUser);
      })
      .catch(err => {
        console.log(err);
        setSnack({
          open: true,
          type: "error",
          message: multiLang["A019"][lang]
        });
        setLoading(false);
      });
  }
  function handleClose() {
    setSnack({
      open: false,
      type: "error",
      message: multiLang["A016"][lang]
    });
  }
  return (
    <div>
      <NewSnack snack={snack} handleClose={handleClose} />
      <Grid container spacing={3}>
        <form
          onSubmit={e => handelSignin(e, "br")}
          style={{ margin: "0 auto" }}
        >
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <TextField
              name="username"
              className={`${classes.TextField} ${dir === "rtl" &&
                (!size ? classes.TextFieldRtl : classes.TextFieldRtlResp)}`}
              variant="outlined"
              type="email"
              label={multiLang["023"][lang]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton disabled edge="end">
                      <Mail />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="password"
              className={`${classes.TextField} ${dir === "rtl" &&
                (!size
                  ? classes.TextFieldPassRtl
                  : classes.TextFieldPassRtlResp)}`}
              variant="outlined"
              type={pass ? "text" : "password"}
              label={multiLang["024"][lang]}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="Toggle password visibility"
                      onClick={() => setPass(!pass)}
                    >
                      {pass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ margin: "20px auto" }}>
            <Button
              variant="contained"
              className={classes.Singin}
              color="primary"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <>
                  <span> {multiLang["026"][lang]}</span>
                  <CircularProgress size={20} thickness={5} />
                </>
              ) : (
                multiLang["021"][lang]
              )}
            </Button>
          </Grid>
        </form>
      </Grid>
    </div>
  );
}

export default LoginForm;
